__turbopack_context__.v({
  "className": "Yno_RG_className",
  "variable": "Yno_RG_variable",
});
